/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './styles.scss';
export function Modal({ title, children, className = '', isOpen, onClose, width = '800px', footer, closeOnOverlayClick = false }) {
    const combinedClassName = `qmb-v2-modal ${className}`;
    useEffect(() => {
        if (!closeOnOverlayClick)
            return undefined;
        const handleOverlayClick = (e) => {
            if (e.target.classList.contains('k-overlay')) {
                onClose();
            }
        };
        document.addEventListener('click', handleOverlayClick);
        return () => document.removeEventListener('click', handleOverlayClick);
    }, [closeOnOverlayClick, onClose]);
    if (!isOpen)
        return null;
    return (React.createElement(Dialog, { title: title, onClose: onClose, className: combinedClassName, width: width },
        React.createElement("div", { className: "qmb-v2-modal__content" }, children),
        footer && React.createElement("div", { className: "qmb-v2-modal__footer" }, footer)));
}
